import {getGsiteValueFromUrl} from '../../offer/business/privateDeals'
export const GSITE_RATE_CHECKER_IDENTIFIER = 'verification'

export const isRateCheckerFromUrl = <T extends Record<string, any>>(
  searchParams: T
) => {
  const gsiteParam = getGsiteValueFromUrl(searchParams)
  return gsiteParam === GSITE_RATE_CHECKER_IDENTIFIER
}
